import { FEATURES } from '/src/features/_global/constants';

export const WHATS_NEW_PERMISSIONS = {
  [FEATURES.WHATS_NEW]: () => ({
    navigate: { allowed: true },
  }),
};
